import {
  BillingReadinessDetail,
  BillingReadinessResponse,
  BillingReadinessWindow,
} from '@chiroup/core/types/BillingReadiness.type';
import { useQuery } from 'react-query';
import billingReadinessService from '../services/billingReadiness.service';

const useBillingReadiness = (
  reportWindow: BillingReadinessWindow,
  enabled = true,
  unexpectedActivity = false
) =>
  useQuery<BillingReadinessResponse>(
    ['billing-readiness', reportWindow, unexpectedActivity],
    () => billingReadinessService.list(reportWindow, unexpectedActivity),
    // Rolls up at most hourly (proc interval), so a 5-min staleTime avoids a
    // refetch on every modal open/close without showing meaningfully stale data.
    { refetchOnWindowFocus: false, enabled, staleTime: 5 * 60 * 1000 }
  );

export const useBillingReadinessDetail = (
  clinicId: number | null,
  reportWindow: BillingReadinessWindow
) =>
  useQuery<BillingReadinessDetail>(
    ['billing-readiness-detail', clinicId, reportWindow],
    () => billingReadinessService.detail(clinicId as number, reportWindow),
    { refetchOnWindowFocus: false, enabled: clinicId != null, staleTime: 5 * 60 * 1000 }
  );

export default useBillingReadiness;
